import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/_layout/notifications/_layout/')({
  component: () => null, // La lista la renderizza il layout parent.
});
